import { Injectable, computed, inject } from '@angular/core';
import { EG_ASSISTANT_CONFIG } from '@expertgroup/assistant';
import { AuthService } from '@/app/core/auth/auth.service';

/**
 * Da li asistent sme da postoji na ekranu — JEDAN uslov za panel u korenu i za pokretač u gornjoj traci.
 *
 * ⚠️⚠️ Zašto zajednički, a ne dve kopije istog izraza: od `@expertgroup/assistant` 0.12.0 zatvoren panel je
 * nevidljiv, a otvara ga pokretač u gornjoj traci. Pokretač bez panela je dugme koje ne radi ništa; panel bez
 * pokretača je dostupan samo onome ko zna za `Ctrl+K`. Dve kopije uslova bi se razišle prvom izmenom jedne.
 *
 * Uključenost se čita iz `EG_ASSISTANT_CONFIG`, ne iz `assistantConfig` iz okruženja: token registruje
 * `provideEgAssistant` tačno kad je konfiguracija ne-null, pa je to ista istina — ali ona koju je DI zaista
 * dobio, i koju test može da postavi bez diranja okruženja. Isti obrazac kao `injectAssistantSession()`.
 *
 * Prijava je drugi uslov: na javnim stranicama asistent nema ni kontekst ni token.
 */
@Injectable({ providedIn: 'root' })
export class AssistantVisibility {
    private readonly enabled = inject(EG_ASSISTANT_CONFIG, { optional: true }) !== null;
    private readonly auth = inject(AuthService);

    readonly visible = computed(() => this.enabled && this.auth.isAuthenticated());
}
